// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPlayer_container__wYnsj"};